const community = {
  events: {
    hero: {
      eyebrow: "અમારી સાથે જોડાઓ",
      title: "દાન કાર્યક્રમો",
      subtitle:
        "Jivandhara ખાતે આગામી પ્રવચનો, ઉત્સવો અને દાન અભિયાનો.",
    },
    tabs: {
      upcoming: "આગામી કાર્યક્રમો",
      past: "વીતેલા કાર્યક્રમો",
    },
    categories: {
      all: "બધા કાર્યક્રમો",
      dharma: "ધર્મ અને પ્રવચન",
      health: "આરોગ્ય કેમ્પ",
      cultural: "સાંસ્કૃતિક અને ઉત્સવ",
      daan: "દાન અભિયાન",
    },
    searchPlaceholder: "કાર્યક્રમ અથવા સ્થળ શોધો...",
    loading: "કાર્યક્રમો લોડ થઈ રહ્યા છે…",
    empty: "કોઈ કાર્યક્રમ મળ્યો નથી.",
    badge: "સમુદાય કાર્યક્રમ",
    viewDetails: "વિગતો જુઓ",
    rsvpBtn: "રજિસ્ટર કરો",
    raised: "એકત્ર {{amount}}",
    goal: "લક્ષ્ય {{amount}}",
    funded: "{{pct}}% ભંડોળ",
    remaining: "બાકી:",
    donateNow: "હમણાં દાન કરો",
    enquire: "પૂછપરછ કરો",
    detailModal: {
      shareEvent: "શેર કરો",
      copied: "લિંક કોપી થઈ!",
      agenda: "કાર્યક્રમ સમયપત્રક",
      getDirections: "નકશો જુઓ",
    },
    rsvpModal: {
      title: "કાર્યક્રમ રજીસ્ટ્રેશન",
      subtitle: "પાસ મેળવવા તમારી હાજરીની પુષ્ટિ કરો",
      successTitle: "રજીસ્ટ્રેશન સફળ!",
      passNotice: "તમારો ડિજિટલ એન્ટ્રી પાસ જનરેટ થઈ ગયો છે",
      fullName: "પૂરું નામ",
      phone: "મોબાઇલ નંબર",
      email: "ઇમેઇલ સરનામું",
      guests: "કુલ સભ્યો",
      specialNeeds: "વિશેષ નોંધ",
      submit: "રજીસ્ટ્રેશન કરો",
      downloadPass: "પાસ ડાઉનલોડ કરો",
    },
  },
  news: {
    hero: {
      eyebrow: "તાજેતરનું",
      title: "સમાચાર અને અપડેટ્સ",
      subtitle: "Jivandhara તરફથી વાર્તાઓ, સિદ્ધિઓ અને જાહેરાતો.",
    },
    empty: "હજુ કોઈ પોસ્ટ નથી.",
  },
  gallery: {
    hero: {
      eyebrow: "ક્ષણો",
      title: "ગેલેરી",
      subtitle: "Jivandhara ખાતે જીવન, સેવા અને ઉજવણીની ઝલક.",
    },
    loading: "લોડ થઈ રહ્યું છે…",
    sampleNote:
      "નમૂના ફોટા બતાવી રહ્યા છીએ — વાસ્તવિક ગેલેરી ટૂંક સમયમાં આવી રહી છે.",
    categories: {
      festivalCelebrations: "ઉત્સવ અને ઉજવણીઓ",
      gaushala: "ગૌશાળા",
      derasar: "દેરાસર",
      outdoorActivities: "બહારની પ્રવૃત્તિઓ",
    },
    empty: "આ શ્રેણીમાં હજુ કોઈ ફોટો નથી.",
  },
  jainPanchang: {
    hero: {
      eyebrow: "આધ્યાત્મિક કેલેન્ડર",
      title: "જૈન પંચાંગ",
      subtitle:
        "જૈન ચંદ્ર કેલેન્ડર પર તિથિ, ઉત્સવ, વ્રત અને પવિત્ર અવલોકનો જુઓ.",
    },
    empty: "આ મહિને હજુ પંચાંગ નોંધો નથી.",
    highlights: {
      loading: "આજનું પંચાંગ લોડ થઈ રહ્યું છે…",
    },
    today: {
      eyebrow: "આજની શુભ તારીખ",
      jainMonth: "જૈન ચંદ્ર મહિનો",
      paksha: "પક્ષ (પંદર દિવસ)",
      currentTithi: "વર્તમાન તિથિ",
      significance: "આજનું મહત્વ",
      viewDetails: "સંપૂર્ણ વિગતો જુઓ",
      donateToday: "આજે દાન કરો",
    },
    upcoming: {
      title: "આગામી મહત્વપૂર્ણ જૈન તિથિઓ",
      details: "વિગતો",
      donate: "દાન",
    },
    calendar: {
      today: "આજે",
      weekdays: "રવિ,સોમ,મંગળ,બુધ,ગુરુ,શુક્ર,શનિ",
      loading: "કેલેન્ડર લોડ થઈ રહ્યું છે…",
      vow: "વ્રત",
    },
    modal: {
      subtitle: "શાસ્ત્ર અને જ્યોતિષ વિગતો",
      lunarCalendar: "જૈન ચંદ્ર કેલેન્ડર",
      monthPaksha: "મહિનો",
      significance: "મહત્વ",
      recommended: "ભલામણ કરેલ વ્રત અને અવલોકનો",
      goBack: "પાછા જાઓ",
      donate: "હમણાં દાન કરો",
    },
  },
  feedback: {
    hero: {
      eyebrow: "અમે સાંભળી રહ્યા છીએ",
      title: "પ્રતિસાદ",
      subtitle: "તમારો અવાજ અમને વધુ સારી સેવા આપવામાં મદદ કરે છે.",
    },
    form: {
      fullName: "પૂરું નામ",
      mobile: "મોબાઇલ",
      email: "ઇમેઇલ",
      type: "પ્રકાર",
      rating: "રેટિંગ",
      message: "સંદેશ",
      submit: "પ્રતિસાદ સબમિટ કરો",
      submitting: "સબમિટ થઈ રહ્યું છે...",
    },
    types: {
      suggestion: "સૂચન",
      complaint: "ફરિયાદ",
      appreciation: "પ્રશંસા",
      other: "અન્ય",
    },
    toast: {
      success: "તમારા પ્રતિસાદ બદલ આભાર!",
      error: "પ્રતિસાદ સબમિટ કરી શકાયો નથી. કૃપા કરીને ફરી પ્રયાસ કરો.",
    },
  },
};

export default community;
